import * as React from 'react';
import { BodyWithMenu } from '../../components/organisms/Menu';
import FeedCard from '../../components/atoms/FeedCard';
import { InvestmentId } from '../../shared/Investment';
import { useParams } from 'react-router-dom';
import Post, { Channel } from '../../shared/Post';
import { getPostById } from '../../globals/ApiHooks';
import Investor from '../../shared/Investor';
import { IsHorizontalMobile, useWindowSize } from '../../globals/UIHooks';
import { SubList } from '.';
import { TranslatedTerms } from '../../globals/TranslatedTerms';
import { lang } from '../../globals/Translations';
import AnalyticsHooks from '../../globals/AnalyticsHooks';
import { ActivityType } from '../../shared/Activity';

export const FeedPageDetailed: React.FC = () => {
  let { id } = useParams<{ id: InvestmentId }>();
  const { width } = useWindowSize()

  const [loading, setLoading] = React.useState<boolean>(false)
  const [post, setPost] = React.useState<Post>()
  const [investor, setInvestor] = React.useState<Investor>()
  const [projectChannels, setProjectChannels] = React.useState<Channel[]>()
  const [defaultChannels, setDefaultChannels] = React.useState<Channel[]>()

  const getPost = async () => {
    setLoading(true)
    const result = await getPostById(id)
    setPost(result?.post)
    setDefaultChannels(result?.defaultChannels)
    setProjectChannels(result?.projectChannels)
    setInvestor(result?.investor)
    setLoading(false)
  }
  React.useEffect(() => { getPost() }, [])

  const small = width && width < 1300
  AnalyticsHooks.LogActivity(ActivityType.FEED_DETAILED_VISIT, { postId: id })
  return (
    <BodyWithMenu loading={loading}>
      <div style={{
        display: 'grid', gridTemplateColumns: small ? "1fr" : "2fr 1fr",
        gridColumnGap: 0, gridRowGap: 20, gridRow: 1, marginTop: 64
      }}>
        <div style={{ display: 'grid', gridRowGap: 20, width: 600, margin: 'auto' }}>
          {post && <FeedCard post={post} />}
        </div>
        {defaultChannels && projectChannels && investor && SubList(defaultChannels, projectChannels, investor)}
      </div>
      <a href='/feed'>{lang(TranslatedTerms.GO_BACK_TO_FEED)}</a>
    </BodyWithMenu>
  )
};
